import { TBreak, TLocation } from '../../../types';

export type TInitialState = {
  startDate: null,
  endDate: null,
  startTime: null,
  endTime: null,
  location: TLocation,
  breaks: Array<TBreak>,
};

const INITIAL_STATE: TInitialState = {
  startDate: null,
  endDate: null,
  startTime: null,
  endTime: null,
  location: {} as TLocation,
  breaks: [] as Array<TBreak>,
};

export {
  INITIAL_STATE,
};
